// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__1dhkL","inner":"Footer_inner__2hq2r","nextIcon":"Footer_nextIcon__oMpCV","innerLeft":"Footer_innerLeft__2gR1G"};